import Utils from './Utils.js';
import Section from './Section.js';
import Common from './Common.js';
import Navi from './Navigation.js';
import WinResize from './WinResize.js';
import Swipe from './SwipeHelper.js';
import SwipeCover from './SwipeHelperCoverMode.js';

class ScrollV {
    constructor(){
        this.comm = Common.instance;
        this.navi = Navi.instance;
        this.winRe = WinResize.instance;

        this.newSec = null;
        this.oldSec = null;
    }

    init(){
        this.scrVCon = this.comm.mainContainer.find('.scr-v');

        let secList = [];
        this.comm.mainContainer.find( '.scr-v > section').each( (idx, el)=>{
            const secItem = new Section(el, idx+1);
            secItem.init();
            secList.push( secItem );
        });
        this.comm.sectionList = secList;

        this.navi.addCallback( _d => this.update(_d) );
        this.winRe.addCallback( () => this.update() );

        this.motionStyle = null;
        if (this.comm.option.motionStyle=='scroll'){
            this.motionStyle = this.motionStyleScroll;
            new Swipe({container: this.scrVCon, direction: 'vertical', dragEl: this.scrVCon});

        } else if(this.comm.option.motionStyle=='cover'){
            this.motionStyle = this.motionStyleCover;
            this.swipe = new SwipeCover({
                container: this.scrVCon,
                direction: 'vertical'
            });
        }
    }

    update( _depth = this.comm.depth ){
        this.newSec = this.comm.sectionList[_depth.d1-1];
        this.newSec.showIn(_depth);

        this.motionStyle(_depth);

        if( this.oldSec && this.oldSec != this.newSec ) this.oldSec.showOut();
        this.oldSec = this.newSec;
    }

    motionStyleScroll(_depth){
        const yPos = -(this.comm.mainContainer[0].clientHeight * (_depth.d1-1));
        let cssObj = {};
            cssObj['transition-duration'] = this.comm.option.transitionDuration + 'ms';
            cssObj[Utils.vPrefix + 'transform'] = `translate(0px, ${yPos}px)`;
            cssObj['transform'] = `translate(0px, ${yPos}px)`;

        this.scrVCon.css(cssObj);
    }

    motionStyleCover(_depth){
        this.comm.sectionList.forEach( item => item.showInCover(_depth) );
    }

}

export default ScrollV;


// WEBPACK FOOTER //
// ./ScrollV.js